const Loader = () => {
  return (
    <>
      <style>{`
      @keyframes loading-bounce {
        0% { transform: scale(1, 0.7); }
        40% { transform: scale(0.85, 1.15); }
        60% { transform: scale(1, 1); }
        100% { bottom: 140px; }
      }

      @keyframes loading-step {
        0% {
          box-shadow: 0 10px 0 rgba(0,0,0,0),
                      0 10px 0 #44CEED,
                      -35px 50px 0 #F696FF,
                      -70px 90px 0 #44CEED;
        }
        100% {
          box-shadow: 0 10px 0 #44CEED,
                      -35px 50px 0 #F696FF,
                      -70px 90px 0 #44CEED,
                      -70px 90px 0 rgba(0,0,0,0);
        }
      }
    `}</style>

      <div className="absolute inset-0 bg-[#DEE3E9]/70 backdrop-blur-sm flex items-center justify-center z-40">
        <div className="relative w-[120px] h-[90px]">
          {/* Bouncing ball */}
          <div
            className="absolute bottom-[30px] left-[50px] h-[30px] w-[30px] rounded-full shadow-md"
            style={{
              background: 'linear-gradient(270deg, #44CEED 0%, #F696FF 100%)',
              animation: 'loading-bounce .5s ease-in-out infinite alternate',
            }}
          />

          {/* Steps */}
          <div
            className="absolute right-0 top-0 h-[7px] w-[45px] rounded-[4px]"
            style={{
              animation: 'loading-step 1s ease-in-out infinite',
              boxShadow: '0 5px 0 #44CEED, -35px 50px 0 #F696FF, -70px 95px 0 #44CEED',
            }}
          />
        </div>
      </div>
    </>
  );
};

export default Loader;
